import {connect} from 'react-redux';
import {Transilluminator as Component} from './Transilluminator';
import {
  createTransilluminator,
  // setTransilluminatorControlVisibility,
  setHeld,
  setHeldObject,
  // showMoveMenu,
  hideAllControls,
  transilluminatorOpen, setModal, showModal,
  toggleToolTipTransillimunatorControls
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("transilluminator") &&
     state.notebook.protocolSection.scene.apparatus.transilluminator.some(
       transilluminator => transilluminator.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id -1].type,
      open: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id -1].open,
      on: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id -1].on,
      containsGel: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id -1].containsGel,
      gelExamined: state.notebook.protocolSection.scene.apparatus.transilluminator[ownProps.id -1].gelExamined,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createTransilluminator: (data) => {
      dispatch(createTransilluminator(data))
    },
    transilluminatorOpen: (data) => {
      dispatch(transilluminatorOpen(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },

    showModal: (data) => {
      dispatch(showModal(data))
    },
    
    toggleToolTipControls: (data) => {
      dispatch(toggleToolTipTransillimunatorControls(data))
    }
  };
}

export const Transilluminator = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
